import { TennisIcon } from './TennisIcon';

/**
 * author: Google
 * id CE166270-170C-4292-8D6F-FE787AF6B021
 * name tennis
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tennis.svg
 * tags
 * - Sport 
 */
export const TennisRacquetIcon = TennisIcon;
export default TennisRacquetIcon